module.exports = __webpack_public_path__ + "static/media/yukari_minoda_600x600.65dc3564.jpg";